<template>
    <div>
        <!-- <TopHeader /> -->
        <MainNavbar />
        <SidebarModal />
        <PageBanner pageTitle="About Us"  backgroundImage="https://img.freepik.com/free-photo/abstract-orange-glowing-lines-background_1017-3201.jpg?t=st=1727373841~exp=1727377441~hmac=d076d2144c41206e97550927c934bd93da539f6bae3409d170f125b6c27e75f6&w=1060"  />
        <AboutOurCompany />
        <PartnerLogo class="partner-logo-area pt-100 pb-75 bg-F4F8FC" />
        <HowWeWork />
        <WhyChooseUs />
        <OurClientTestimonial />
        <ContactUs />
        <FunFect class="pt-100" />
        <SubscribeNewsletter />
        <MainFooter />
    </div>
</template>

<script>
// import TopHeader from '../Layouts/TopHeader'
import MainNavbar from '../Layouts/MainNavbar'
import SidebarModal from '../Layouts/SidebarModal'
import PageBanner from '../Common/PageBanner'
import AboutOurCompany from '../HomeOne/AboutOurCompany'
import PartnerLogo from '../Common/PartnerLogo'
import HowWeWork from '../HomeOne/HowWeWork'
import WhyChooseUs from '../HomeOne/WhyChooseUs'
import OurClientTestimonial from '../HomeOne/OurClientTestimonial'
import ContactUs from '../HomeOne/ContactUs'
import FunFect from '../Common/FunFect'
import SubscribeNewsletter from '../Common/SubscribeNewsletter'
import MainFooter from '../Layouts/MainFooter'

export default {
    name: 'AboutOnePage',
    components: {
        //  TopHeader,
        MainNavbar,
        SidebarModal,
        PageBanner,
        AboutOurCompany,
        PartnerLogo,
        HowWeWork,
        WhyChooseUs,
        OurClientTestimonial,
        ContactUs,
        FunFect,
        SubscribeNewsletter,
        MainFooter,
    }
}
</script>